import { Button } from "@/components/Button";
import { useRegistration } from "../context/registration-context";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { SuccessCheck } from "@/components/SuccessCheck/SuccessCheck";


interface FinalResultsProps {
  onBack?: () => void;
  onContinueToPortal?: () => void;
  onBackToHomepage?: () => void;
}

export const FinalResults: React.FC<FinalResultsProps> = ({
  onBack,
  onContinueToPortal,
  onBackToHomepage
}) => {
  const { formData } = useRegistration();

  // Determine success/failure based on form data
  const isSuccess = formData.hasAutismDiagnosis === true;

  const handleContinueToPortal = () => {
    console.log('🚀 User clicked Continue to Portal');
    onContinueToPortal?.();
  };

  const handleBackToHomepage = () => {
    console.log('🏠 User clicked Back to Homepage');
    onBackToHomepage?.();
  };

  const handleIHaveDiagnosis = () => {
    console.log('🔙 User clicked I have a diagnosis - going back to diagnostic form');
    if (onBack) {
      onBack();
    }
  };

  if (isSuccess) {
    return (
      <div className="bg-white p-8 rounded-[16px] relative overflow-hidden">
        <div className="text-center relative z-10">
          {/* Success Check with Confetti */}
          <div className="mx-auto mb-6">
            <SuccessCheck />
          </div>

          {/* Success Message */}
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Thank you!
          </h1>
          
          <div className="max-w-2xl mx-auto text-gray-600 space-y-4 mb-8">
            <p className="text-base">
              A member of the Headstart team will give you a call to discuss next steps within 24 hours. In the meantime, please proceed to complete your intake questionnaire.
            </p>
            
            <p className="text-base">
              Feel free to message us through the portal or call us at <span className="font-semibold text-primary">(478) 347-6197</span> at anytime.
            </p>
          </div>

          {/* Continue Button */}
          <div className="flex justify-center">
            <Button
              variant="primary"
              className="!rounded-full px-8 py-3 text-lg font-semibold"
              onClick={handleContinueToPortal}
            >
              Continue to Portal
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white p-8 rounded-[16px]">
      <div className="text-center">
        {/* Info Icon */}
        <div className="mx-auto mb-6 w-10 h-10 rounded-full bg-secondary border border-gray-200 shadow-sm flex items-center justify-center">
          <FontAwesomeIcon icon={faInfoCircle} className="h-5 w-5 text-primary" />
        </div>

        {/* Failure Message */}
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Insurance Requires an Autism Diagnosis
        </h1>
        
        <div className="max-w-2xl mx-auto text-gray-600 space-y-4 mb-8">
          <p className="text-lg">
            Insurance requires an autism diagnosis to receive ABA therapy. Headstart can connect you with diagnosing providers in your area. A member of the Headstart team will reach out to you shortly to discuss next steps.
          </p>
          
          <p className="text-base">
            Please call us at <span className="font-semibold text-primary">(478) 347-6197</span> if you have any questions in the meantime.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="space-y-4">
          <Button
            variant="primary"
            className="!rounded-full px-8 py-3 text-lg font-semibold w-full"
            onClick={handleBackToHomepage}
          >
            Back to Homepage
          </Button>
          
          <div className="text-center">
            <button
              className="text-primary font-semibold hover:text-primary/80 underline"
              onClick={handleIHaveDiagnosis}
            >
              I have a diagnosis
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}; 